export const menulist = [
    // {
    //     id: '30001',
    //     name: 'station',
    //     text: '站点管理',
    //     icon: 'android-desktop',
    //     children: [{
    //         id: '30001001',
    //         name: 'platform',
    //         text: '模板管理',
    //         url: '/homeMain/station/platform'
    //     }]
    // },
    {
        id: '30002',
        name: 'mdse',
        text: '商品管理',
        icon: 'social-buffer',
        children: [{
                id: '30002001',
                name: 'storegoods',
                text: '商品中心',
                url: '/homeMain/mdse/storegoods'
            },
        ]
    },
    // {
    //     id: '30003',
    //     name: 'members',
    //     text: '会员管理',
    //     icon: 'android-person',
    //     children: [
    //         {
    //             id: '30003001',
    //             name: 'member',
    //             text: '会员管理',
    //             url: '/homeMain/member/member'
    //         }
    //     ]
    // },
    {
        id: '30004',
        name: 'transacts',
        text: '交易管理',
        icon: 'social-usd',
        children: [{
                id: '30004001',
                name: 'order',
                text: '订单管理',
                url: '/homeMain/transacts/order'
            },
            {
                id: '30004002',
                name: '评价管理',
                text: '评价管理',
                url: '/homeMain/transacts/appraise'
            },
            {
                id: '30004003',
                name: 'returngoods',
                text: '退货管理',
                url: '/homeMain/transacts/returngoods'
            },
        ]
    },
    {
        id: "30015",  // new 
        name: "customization",
        text: "定制订单管理",
        icon: "social-usd",
        children: [
            {
                id: "30015001",
                name: "invoice",
                text: "定制订单",
                icon: "ionic",
                url: "/customization"
            }
        ]
    },
    {
        id: '30005',
        name: 'logistics',
        text: '物流信息',
        icon: 'android-bus',
        children: [{
            id: '30005001',
            name: 'freight',
            text: '运费模板',
            url: '/homeMain/logistics/freight'
        }, ]
    },
    {
        id: '30006',
        name: 'settlement',
        text: '结算管理',
        icon: 'cash',
        children: [{
                id: '30006001',
                name: 'salessettlement',
                text: '销售结算',
                url: '/homeMain/settlement/salessettlement'
            }

        ]
    },

    {
        id: '30007',
        name: 'marketing',
        text: '营销管理',
        icon: 'social-dropbox',
        children: [{
                id: '30007001',
                name: 'createcampaign',
                text: '营销活动中心',
                url: '/homeMain/newMarket/marketCenter'
            },
            {
                id: '30007002',
                name: 'managercampaign',
                text: '营销活动管理',
                url: '/homeMain/newMarket/manage'
            },
            {
                id: '30007003',
                name: 'registercampaign',
                text: '营销活动报名',
                url: '/homeMain/marketing/registercampaign'
            },
        ]
    },

    {
        id: '30008',
        name: 'systemmanagement',
        text: '系统管理',
        icon: 'android-settings',
        children: [{
                id: '30008001',
                name: 'rolemanagement',
                text: '角色权限管理',
                url: '/homeMain/systemmanagement/rolemanagement'
            },
            {
                id: '30008002',
                name: 'management',
                text: '人员管理',
                url: '/homeMain/systemmanagement/personelManage'
            }, 
        ]
    }, 
    {
        id: '30009',
        name: 'couponsmanagement',
        text: '优惠券管理',
        icon: 'bag',
        children: [{
                id: '30009001',
                name: 'couponsissuingmanagement',
                text: '优惠券发行管理',
                url: '/homeMain/couponsmanagement/couponsissuingmanagement'
            },
            {
                id: '30009002',
                name: 'couponsinfomanagement',
                text: '优惠券信息管理',
                url: '/homeMain/couponsmanagement/couponsinfomanagement'
            },
        ]
    },
    {
        id: '30010',
        text: '店铺管理',
        name:'storeManger',
        icon: 'bag',
        children: [
            {
                id: '30010001',
                name: 'storeinfor',
                text: '商家信息',
                url: '/homeMain/systemmanagement/storeinfor'
            },{
                id: '30010002',
                name:'storeDecorate',
                text: '店铺装修',
                url: '/homeMain/storemanager/storedecorate'
            }
            
        ]
    },
    // {
    //     id: '30011',
    //     text: '客服管理',
    //     name:'custom',
    //     icon: 'bag',
    //     children: [
    //         {
    //             id: '30011001',
    //             name: 'qiyucustom',
    //             text: '客服后台',
    //             url: '/homeMain/custom/qykf'
    //         },
			
    //     ]
    // }
]


// WEBPACK FOOTER //
// ./src/common/js/menu.js